export const creditCardsPtBr = {
  glOffsetErrors: {
    NOT_FOUND: 'A conta contábil selecionada não foi encontrada. Selecione outra conta.',
    WRONG_VERSION:
      'A conta contábil selecionada não pertence ao plano de contas em vigor para esta entidade.',
    WRONG_CLASSIFICATION: 'Selecione uma conta de passivo com natureza credora.',
    NOT_POSTABLE: 'Selecione uma conta analítica, que aceita lançamentos.',
    INACTIVE: 'A conta contábil selecionada está inativa. Selecione uma conta ativa.',
    SLOT_MAPPED:
      'Esta conta já está configurada como conta de sistema no mapeamento de contas. Selecione outra conta.',
    BOUND_TO_OTHER_SUBJECT:
      'Esta conta já está vinculada a um fornecedor, cliente ou conta bancária. Selecione outra conta.',
    UNDER_OTHER_ROOT:
      'Esta conta fica sob a conta raiz de outra finalidade no mapeamento de contas. Selecione outra conta.',
    COA_ASSIGNMENT_REQUIRED:
      'Esta entidade ainda não tem livro contábil com plano de contas ativo. Configure o livro e atribua um plano de contas antes de vincular uma conta contábil.',
    fallback:
      'A conta contábil selecionada não pode ser vinculada a este cartão. Selecione outra conta.',
  },
  page: {
    proposedListTitle: 'Cartões de crédito',
    titleCreate: 'Novo Cartão de Crédito',
    titleEdit: 'Editar Cartão de Crédito',
    subtitleCreate: 'Preencha os dados para criar um novo cartão de crédito',
    subtitleEdit: 'Atualize as informações do cartão de crédito',
  },
  sections: {
    basic: 'Informações Básicas',
    cardData: 'Dados do Cartão',
    billing: 'Ciclo de Faturamento',
    limits: 'Limites',
    payment: 'Conta de Pagamento',
    advanced: 'Campos Avançados',
  },
  fields: {
    entity: 'Entidade',
    currency: 'Moeda da fatura',
    status: 'Status',
    name: 'Nome',
    description: 'Descrição',
    brand: 'Bandeira',
    lastFourDigits: 'Últimos 4 Dígitos',
    cardholderName: 'Titular do Cartão',
    cardholderEmail: 'E-mail do titular',
    expirationMonth: 'Mês de Validade',
    expirationYear: 'Ano de Validade',
    creditLimit: 'Limite de Crédito',
    availableLimit: 'Limite Disponível',
    closingDay: 'Dia de Fechamento',
    dueDay: 'Dia de Vencimento',
    paymentBankAccount: 'Conta Bancária',
    financialInstitution: 'Instituição financeira emissora',
    glOffsetAccount: 'Conta contábil',
    costCenter: 'Centro de custo',
    department: 'Departamento',
    isDefault: 'Definir como cartão padrão',
  },
  placeholders: {
    selectEntity: 'Selecione a entidade',
    selectCurrency: 'Selecione a moeda',
    selectStatus: 'Selecione o status',
    name: 'Ex: Cartão Corporativo Bradesco',
    description: 'Descrição opcional do cartão de crédito',
    selectBrand: 'Selecione a bandeira',
    lastFourDigits: 'Ex: 1234',
    cardholderName: 'Ex: JOÃO DA SILVA',
    cardholderEmail: 'Ex: joao.silva@empresa.com',
    month: 'Mês',
    year: 'Ano',
    creditLimit: 'Ex: 10.000,00',
    availableLimit: 'Ex: 5.000,00',
    closingDay: 'Ex: 15',
    dueDay: 'Ex: 25',
    selectBankAccount: 'Selecione a conta bancária',
    selectFinancialInstitution: 'Selecione o banco emissor',
    selectPaymentBankAccount: 'Selecione a conta que paga a fatura',
    selectGlAccount: 'Selecione a conta contábil para vincular na GL',
    selectDepartment: 'Selecione o departamento',
    selectCostCenter: 'Selecione o centro de custo',
  },
  hints: {
    expirationPastWarning: 'A data de validade deve ser futura',
    lastFourDigits: '4 dígitos numéricos',
    limits: 'Valores na moeda da fatura ({{currency}})',
    currencyImmutable: 'A moeda não pode ser alterada após a criação do cartão.',
    currencyMultipleAccounts:
      'Selecione uma conta provedora específica antes de alterar a moeda deste cartão.',
    currencyManagedByProvider: 'A moeda deste cartão é mantida pela sincronização do provedor.',
    billingDays: 'Dia do mês (1-31)',
    paymentAccount: 'Conta bancária utilizada para pagamento da fatura',
    paymentBankAccount:
      'Conta bancária da mesma instituição utilizada para pagar a fatura. Sem essa conta, a projeção de liquidação e o fluxo de caixa do cartão ficam incompletos.',
    paymentBankAccountMismatch: 'A conta deve pertencer ao banco emissor selecionado.',
    entityRequiredForBank: 'Selecione uma entidade para ver as contas bancárias disponíveis',
    glOffsetHint:
      'Será criada automaticamente no primeiro lançamento, mas você pode selecionar uma agora caso já exista uma conta para esse cartão.',
    glOptionsLoadError: 'Não foi possível carregar as contas contábeis deste cartão.',
    glOptionsRetry: 'Tentar novamente',
    glOffsetHintDirect:
      'Selecione a conta analítica de passivo deste cartão. Sem ela, o lançamento não é contabilizado até você selecioná-la. A conta raiz só é escolhida no mapeamento de contas.',
    dimensions:
      'Dimensões opcionais da contabilidade (mesma entidade do cartão); usadas como padrão quando aplicável.',
    clear: 'Limpar',
  },
  validation: {
    proposedEntityRequired: 'Selecione a entidade',
    proposedNameRequired: 'Informe o nome',
    proposedInstitutionRequired: 'Informe a instituição emissora',
    proposedBankAccountRequired: 'Informe a conta bancária que paga a fatura',
    proposedCurrencyRequired: 'Selecione a moeda da fatura',
    proposedBrandRequired: 'Selecione a bandeira',
    proposedLastFourDigits: 'Informe os quatro últimos dígitos numéricos',
    proposedCardholderRequired: 'Informe o titular do cartão',
    proposedMonthInvalid: 'Selecione um mês entre 1 e 12',
    proposedYearInvalid: 'Selecione um ano válido',
    proposedDayInvalid: 'Selecione um dia entre 1 e 31',
  },
  toasts: {
    createSuccess: 'Cartão de crédito criado com sucesso',
    updateSuccess: 'Cartão de crédito atualizado com sucesso',
  },
  actions: {
    proposedCreate: 'Criar cartão de crédito',
    proposedSaveChanges: 'Salvar alterações',
    proposedContinue: 'Continuar',
    proposedBack: 'Voltar',
    cancel: 'Cancelar',
    save: 'Salvar',
  },
  statusOptions: {
    ACTIVE: 'Ativo',
    INACTIVE: 'Inativo',
    CANCELLED: 'Cancelado',
    EXPIRED: 'Expirado',
    DRAFT: 'Rascunho',
  },
  brandOptions: {
    VISA: 'Visa',
    MASTERCARD: 'Mastercard',
    AMEX: 'American Express',
    ELO: 'Elo',
    HIPERCARD: 'Hipercard',
    DINERS: 'Diners Club',
    OTHER: 'Outro',
  },
};

export const creditCardsEn = {
  glOffsetErrors: {
    NOT_FOUND: 'The selected accounting account was not found. Select another account.',
    WRONG_VERSION:
      'The selected accounting account is not in the chart of accounts in force for this entity.',
    WRONG_CLASSIFICATION: 'Select a liability account with a credit balance.',
    NOT_POSTABLE: 'Select a posting account.',
    INACTIVE: 'The selected accounting account is inactive. Select an active account.',
    SLOT_MAPPED:
      'This account is already configured as a system account in account mapping. Select another account.',
    BOUND_TO_OTHER_SUBJECT:
      'This account is already linked to a vendor, customer or bank account. Select another account.',
    UNDER_OTHER_ROOT:
      'This account sits under a root account mapped for another purpose. Select another account.',
    COA_ASSIGNMENT_REQUIRED:
      'This entity has no book with an active chart of accounts yet. Set up its book and assign a chart of accounts before linking an accounting account.',
    fallback:
      'The selected accounting account cannot be linked to this card. Select another account.',
  },
  page: {
    proposedListTitle: 'Credit cards',
    titleCreate: 'New Credit Card',
    titleEdit: 'Edit Credit Card',
    subtitleCreate: 'Fill in the data to create a new credit card',
    subtitleEdit: 'Update the credit card information',
  },
  sections: {
    basic: 'Basic Information',
    cardData: 'Card Data',
    billing: 'Billing Cycle',
    limits: 'Limits',
    payment: 'Payment Account',
    advanced: 'Advanced Fields',
  },
  fields: {
    entity: 'Entity',
    currency: 'Billing currency',
    status: 'Status',
    name: 'Name',
    description: 'Description',
    brand: 'Brand',
    lastFourDigits: 'Last 4 Digits',
    cardholderName: 'Cardholder Name',
    cardholderEmail: 'Cardholder email',
    expirationMonth: 'Expiration Month',
    expirationYear: 'Expiration Year',
    creditLimit: 'Credit Limit',
    availableLimit: 'Available Limit',
    closingDay: 'Closing Day',
    dueDay: 'Due Day',
    paymentBankAccount: 'Bank Account',
    financialInstitution: 'Issuing financial institution',
    glOffsetAccount: 'Accounting account',
    costCenter: 'Cost center',
    department: 'Department',
    isDefault: 'Set as default card',
  },
  placeholders: {
    selectEntity: 'Select entity',
    selectCurrency: 'Select currency',
    selectStatus: 'Select status',
    name: 'e.g. Corporate Bradesco Card',
    description: 'Optional credit card description',
    selectBrand: 'Select brand',
    lastFourDigits: 'e.g. 1234',
    cardholderName: 'e.g. JOHN DOE',
    cardholderEmail: 'e.g. john.doe@company.com',
    month: 'Month',
    year: 'Year',
    creditLimit: 'e.g. 10,000.00',
    availableLimit: 'e.g. 5,000.00',
    closingDay: 'e.g. 15',
    dueDay: 'e.g. 25',
    selectBankAccount: 'Select bank account',
    selectFinancialInstitution: 'Select issuing bank',
    selectPaymentBankAccount: 'Select the account that pays the invoice',
    selectGlAccount: 'Select accounting account to link in GL',
    selectDepartment: 'Select department',
    selectCostCenter: 'Select cost center',
  },
  hints: {
    expirationPastWarning: 'Expiration date must be in the future',
    lastFourDigits: '4 numeric digits',
    limits: 'Values in the billing currency ({{currency}})',
    currencyImmutable: 'Currency cannot be changed after the card is created.',
    currencyMultipleAccounts:
      'Select a specific provider account before changing this card’s currency.',
    currencyManagedByProvider: 'This card’s currency is maintained by provider synchronization.',
    billingDays: 'Day of month (1-31)',
    paymentAccount: 'Bank account used for invoice payment',
    paymentBankAccount:
      'Bank account from the same institution used to pay the invoice. Without it, card settlement projection and cash-flow visibility stay incomplete.',
    paymentBankAccountMismatch: 'The account must belong to the selected issuing bank.',
    entityRequiredForBank: 'Select an entity to see available bank accounts',
    glOffsetHint:
      'Accounting account will be created automatically on the first posting, but you can select one now if an account already exists for this card.',
    glOptionsLoadError: 'Could not load the accounting accounts for this card.',
    glOptionsRetry: 'Try again',
    glOffsetHintDirect:
      "Select this card's liability posting account. Without it, the entry is not posted until you select one. The root account is chosen only in account mapping.",
    dimensions:
      'Optional accounting dimensions (same entity as the card); used as defaults where applicable.',
    clear: 'Clear',
  },
  validation: {
    proposedEntityRequired: 'Select the entity',
    proposedNameRequired: 'Enter the name',
    proposedInstitutionRequired: 'Select the issuer',
    proposedBankAccountRequired: 'Select the bank account that pays the invoice',
    proposedCurrencyRequired: 'Select the billing currency',
    proposedBrandRequired: 'Select the brand',
    proposedLastFourDigits: 'Enter the last four numeric digits',
    proposedCardholderRequired: 'Enter the cardholder name',
    proposedMonthInvalid: 'Select a month from 1 to 12',
    proposedYearInvalid: 'Select a valid year',
    proposedDayInvalid: 'Select a day from 1 to 31',
  },
  toasts: {
    createSuccess: 'Credit card created successfully',
    updateSuccess: 'Credit card updated successfully',
  },
  actions: {
    proposedCreate: 'Create credit card',
    proposedSaveChanges: 'Save changes',
    proposedContinue: 'Continue',
    proposedBack: 'Back',
    cancel: 'Cancel',
    save: 'Save',
  },
  statusOptions: {
    ACTIVE: 'Active',
    INACTIVE: 'Inactive',
    CANCELLED: 'Cancelled',
    EXPIRED: 'Expired',
    DRAFT: 'Draft',
  },
  brandOptions: {
    VISA: 'Visa',
    MASTERCARD: 'Mastercard',
    AMEX: 'American Express',
    ELO: 'Elo',
    HIPERCARD: 'Hipercard',
    DINERS: 'Diners Club',
    OTHER: 'Other',
  },
};
